import Helper from "@/services/Helper"

export default class Drafts {
    filterParams() {
        return {
            params: {
                search: "",
                search_full_match: true,
                date: null,
                users: [],
                statuses: {
                    published: false,
                    scheduled: false,
                    removed: false,
                    draft: true,
                },
                shops: [],
                categories: [],
                type_visibility: null,
                type_ids: [],
                is_moderate: null,
                type_id: [],
                promocode: "",
            },
            saveForm: false,
            enable: false,
        }
    }

    prepareQuery(q) {
        let query = Helper.clone(q)

        return query
    }
}
